import React from 'react';
import styled from 'styled-components';
import { FilterButton as FilterBtn } from '../../../../../styles/theme/default/buttons';

const Wrapper = styled.div`
  .filter-btn {
    min-width: 110px;
  }

  .filter-btn {
    i {
      margin-right: 7px;
    }
  }
`;

function FilterButton({ onClick, totalItemsFilters }) {
  const hasItemsSelected = totalItemsFilters > 0;
  return (
    <Wrapper>
      <CustomFilterBtn
        selected={hasItemsSelected}
        className="filter-btn"
        onClick={onClick}
      >
        <i className="fas fa-sliders-h" />
        Filters {hasItemsSelected && `(${totalItemsFilters})`}
      </CustomFilterBtn>
    </Wrapper>
  );
}

export default FilterButton;

const CustomFilterBtn = styled(FilterBtn)`
  border: ${({ selected }) =>
    selected ? '1px solid black' : '1px solid #D8D8D8'};
  color: ${({ selected, theme }) => (selected ?  theme.colors.charcoal: '#4B4B4B')};
`;
